import React, { useState } from 'react';
import ImovelList from '../components/ImovelList';
import ImovelForm from '../components/ImovelForm';
import { Container, Typography, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { actionButtonSx, pageTitleSx } from '../styles/uiTokens';

function ImoveisPage() {
  const [refreshList, setRefreshList] = useState(false);
  const [editingImovel, setEditingImovel] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleImovelAdded = () => {
    setRefreshList((prev) => !prev);
    setEditingImovel(null);
    setShowForm(false);
  };

  const handleEditImovel = (imovel) => {
    setEditingImovel(imovel);
    setShowForm(true);
  };

  const handleCancelEditImovel = () => {
    setEditingImovel(null);
    setShowForm(false);
  };

  const handleImovelDeleted = () => {
    setRefreshList((prev) => !prev);
  };

  const handleShowForm = () => {
    setEditingImovel(null);
    setShowForm(true);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Gerenciar Im&oacute;veis
        </Typography>
        {!showForm && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleShowForm}
            sx={actionButtonSx}
          >
            Adicionar Im&oacute;vel
          </Button>
        )}
      </Box>

      {showForm && (
        <ImovelForm
          onImovelAdded={handleImovelAdded}
          initialData={editingImovel}
          onCancelEdit={handleCancelEditImovel}
        />
      )}

      {!showForm && (
        <ImovelList
          refresh={refreshList}
          onEdit={handleEditImovel}
          onImovelDeleted={handleImovelDeleted}
        />
      )}
    </Container>
  );
}

export default ImoveisPage;
